(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dianu-care-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.dianu-care-guide');

    sections.forEach((section) => {
      if (section.dataset.careFilterReady === 'true') return;

      const grid = section.querySelector('[data-care-grid]');
      const feedHeading = section.querySelector('.dianu-care-guide__feed-heading');
      const cards = Array.from(section.querySelectorAll('[data-care-category]'));
      const filters = Array.from(section.querySelectorAll('.dianu-care-guide__filter'));
      const pathLinks = Array.from(section.querySelectorAll('.dianu-care-guide__path-item[data-care-filter]'));
      const status = section.querySelector('.dianu-care-guide__filter-status');
      const labels = {
        all: 'care guides',
        hydration: 'hydration guides',
        cleaning: 'cleaning guides',
        'multi-pet': 'multi-pet guides'
      };

      if (!grid || cards.length === 0) return;

      const counts = cards.reduce((summary, card) => {
        const category = card.dataset.careCategory || 'hydration';
        summary.all += 1;
        summary[category] = (summary[category] || 0) + 1;
        return summary;
      }, { all: 0, hydration: 0, cleaning: 0, 'multi-pet': 0 });

      Object.entries(counts).forEach(([category, count]) => {
        section.querySelectorAll(`[data-care-count="${category}"]`).forEach((countElement) => {
          countElement.textContent = count;
        });
      });

      const applyFilter = (filter, scrollToGrid = false) => {
        const activeFilter = filter || 'all';
        let visibleCount = 0;

        cards.forEach((card) => {
          const showCard = activeFilter === 'all' || card.dataset.careCategory === activeFilter;
          card.classList.toggle('is-hidden', !showCard);
          if (showCard) visibleCount += 1;
        });

        filters.forEach((button) => {
          const isActive = button.dataset.careFilter === activeFilter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (status) {
          status.textContent = `Showing ${visibleCount} ${labels[activeFilter] || 'care guides'}.`;
        }

        if (scrollToGrid) {
          (feedHeading || grid).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          applyFilter(button.dataset.careFilter || 'all', false);
        });
      });

      pathLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          applyFilter(link.dataset.careFilter || 'all', true);
        });
      });

      section.dataset.careFilterReady = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
